import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { GamificationModalUserPhotoContainer } from "shared/components/molecules/Gamification/GamificationModal/atoms/UserPhoto/styles";
import { NotificationContainerWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer/styles";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const LosePodiumNotificationContainer = styled.div`
  ${NotificationContainerWrapper} {
    grid-template-columns: auto 1fr auto;

    background: linear-gradient(
      90deg,
      rgba(236, 52, 52, 0.12) 0%,
      rgba(104, 20, 20, 0.12) 100%
    );

    border-left: 2px solid #ff4949;
  }

  .user-info {
    position: relative;

    min-width: 90px;
    min-height: 60px;
    height: fit-content;

    @media (max-width: 1366px) {
      min-height: 40px;
    }

    overflow: hidden;

    align-self: center;

    ${SimpleUserInitialsNameContainer}, ${GamificationModalUserPhotoContainer} img {
      width: 61px !important;
      height: 61px !important;

      @media (max-width: 1366px) {
        width: 40px !important;
        height: 40px !important;

        h1 {
          font-size: 0.875rem;
        }
      }
    }

    .circular-progress {
      width: 67px !important;
      height: 67px !important;

      @media (max-width: 1366px) {
        width: 50px !important;
        height: 50px !important;
      }
    }

    .right-starts-icon,
    .left-starts-icon {
      width: 15px;
      height: 15px;
    }

    ${GamificationModalUserPhotoContainer} {
      margin-bottom: 0;
    }

    .sad-face-1 {
      left: 6px;
      top: 66px;
      transform: rotate(358deg);

      @media (max-width: 1366px) {
        width: 20px;
        height: 20px;

        left: 14px;
        top: 50px;
      }
    }

    .sad-face-2 {
      right: 14px;
      top: 76px;
      transform: rotate(27deg);

      @media (max-width: 1366px) {
        width: 16px;
        height: 16px;

        right: 22px;
        top: 57px;
      }
    }

    img[class^="sad-face"] {
      position: absolute;
    }

    .position-tag {
      background-color: ${({ theme }) =>
        theme.mode === "dark" ? "#8c3223" : "#b1b1b1"};
      border-radius: 3px;

      padding: 0.1875rem 0.375rem;

      width: fit-content;

      font: 600 0.75rem/0.9375rem "Inter";
      color: #ffffff;

      display: flex;
      align-items: center;
      justify-content: center;

      margin: 0px auto 10px auto;

      z-index: 2;
      position: relative;
    }

    .podium {
      width: 120px;
      height: 50px;

      position: absolute;
      left: 50%;
      top: 20%;
      transform: translate(-50%, -50%);

      z-index: 0;
    }
  }
`;

export const SeeRankingButton = styled(ConsolePageButtonStyles)`
  padding: 0;

  margin: 12px 0;

  background-color: #fe4949 !important;
  color: #000000;

  @media (max-width: 1366px) {
    width: 100%;
  }

  a {
    padding: 0.5rem 1rem;
  }
`;
